// Enterprise semantic status badge — see /app/memory/DESIGN_SYSTEM.md §13
import { cn } from '@/lib/utils';

const TONES = {
  success: 'bg-emerald-50 text-emerald-800 border-emerald-300',
  warning: 'bg-amber-50 text-amber-900 border-amber-300',
  danger: 'bg-rose-50 text-rose-800 border-rose-300',
  info: 'bg-blue-50 text-blue-800 border-blue-300',
  neutral: 'bg-zinc-100 text-zinc-800 border-zinc-300',
};

export const StatusBadge = ({ tone = 'neutral', children, className, testid }) => (
  <span
    data-testid={testid}
    className={cn('inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold border whitespace-nowrap', TONES[tone] || TONES.neutral, className)}
  >
    {children}
  </span>
);
